// extracted by mini-css-extract-plugin
module.exports = {"addSlot":"SlotList_addSlot__2gOzT","panelList":"SlotList_panelList__13F0V","addFirstSlot":"SlotList_addFirstSlot__1jWLQ","placeholder":"SlotList_placeholder__2NEcy"};